import { Button, Grid, InputAdornment, TextField } from "@mui/material";
import { useSuperAdminSuscripts } from "../../../context/SuperAdmin/SuscriptsContext";
import { useAuthContext } from "../../../hooks/Auth";
import SearchIcon from "@mui/icons-material/Search";

const HeaderSuscriptTable = () => {
  const { toggleCreateModal, setSearchText, searchText } =
    useSuperAdminSuscripts();
  const { canAccess } = useAuthContext();
  return (
    <Grid
      container
      sx={{ justifyContent: "space-between", alignContent: "center" }}
    >
      <Grid item>
        {/* Search bar */}
        <TextField
          size="small"
          variant="outlined"
          placeholder="Ej: Plan Oro"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Grid>

      {canAccess("create:suscriptions") && (
        <Grid item>
          <Button
            variant="contained"
            onClick={() => toggleCreateModal(true)}
            sx={{ background: "#336B87" }}
          >
            Crear suscripción
          </Button>
        </Grid>
      )}
    </Grid>
  );
};

export default HeaderSuscriptTable;
